module.exports = __webpack_public_path__ + "static/media/voucher1@2x.91e2f447.png";